import http from './http';

export const emergencyAPI = {
  // Get all emergency cases
  getEmergencies: (params = {}) => {
    return http.get('/emergency', { params });
  },

  // Get emergency by ID
  getEmergency: (id) => {
    return http.get(`/emergency/${id}`);
  },

  // Create new emergency case
  createEmergency: (data) => {
    return http.post('/emergency', data);
  },

  // Update emergency case
  updateEmergency: (id, data) => {
    return http.put(`/emergency/${id}`, data);
  },

  // Update emergency status
  updateEmergencyStatus: (id, status) => {
    return http.patch(`/emergency/${id}/status`, { status });
  },

  // Delete emergency case
  deleteEmergency: (id) => {
    return http.delete(`/emergency/${id}`);
  },

  // Get emergency statistics
  getEmergencyStats: (params = {}) => {
    return http.get('/emergency/stats', { params });
  },

  // Emergency triage
  triageEmergency: (id, triageData) => {
    return http.post(`/emergency/${id}/triage`, triageData);
  },

  // Transfer emergency patient
  transferEmergency: (id, transferData) => {
    return http.post(`/emergency/${id}/transfer`, transferData);
  },

  // Emergency discharge
  dischargeEmergency: (id, dischargeData) => {
    return http.post(`/emergency/${id}/discharge`, dischargeData);
  }
};